import { registerVueComponentAndAngularBindings } from '/vodalys/vvuejs'

import Branding from './Branding.vue'
registerVueComponentAndAngularBindings('branding:page', 'branding', Branding)